import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import './CoreValuesSection.css'; // for custom styles if needed
import clientImage from '../assets/live.jpg';

const CoreValuesSection = () => {
  return (
    <section className="CoreValue">
    <div className="container py-5">
      <div className="row align-items-center">
        {/* Left Image - slide in from left */}
        <div className="col-md-5 text-center mb-4 mb-md-0 slide-in-left">
          <img
            src={clientImage}
            alt="Woman with laptop"
            className="img-fluid rounded"
          />
        </div>

        {/* Right Content - slide in from right */}
        <div className="col-md-7 slide-in-right">
          <small className="text-uppercase text-purple1 fw-bold">Our Value</small>
          <h1 className="fw-bold my-3" style={{ color: '#f5d7e3' }}>
            Emphasizing Core Values For Prioritizing Your Needs And Preferences.
          </h1>
          <p className="text-muted1">
        We are driven by a deep commitment to integrity, innovation, and customer satisfaction. Our team takes the time to understand your goals, ensuring every solution is tailored to meet your unique needs while exceeding expectations at every stage.
          </p>

          <div className="bg-purple-gradient text-white rounded p-4 mt-4">
            <div className="row">
              {/* Feature 1 */}
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill me-2 fs-5"></i>
                  <div>
                    <h6 className="fw-bold3 mb-1">Client–Centric Approach</h6>
                    <p className="mb-0">We prioritize your goals at every step, delivering personalized solutions and consistent support to ensure your complete satisfaction.</p>
                  </div>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill me-2 fs-5"></i>
                  <div>
                    <h6 className="fw-bold3 mb-1">Innovation And Creativity</h6>
                    <p className="mb-0">We blend cutting-edge ideas with creative strategies to deliver standout solutions that keep you ahead in a competitive landscape.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Progress Bars */}
            <div className="mt-4">
              <h6 className="fw-bold text-white">Innovation Events</h6>
              <ProgressBar now={90} label="90%" className="mb-3 progress-bar-purple" />

              <h6 className="fw-bold text-white">Event Success Rate</h6>
              <ProgressBar now={98} label="98%" className="progress-bar-purple" />
            </div>
          </div>
        </div>
      </div>
    </div></section>
  );
};

export default CoreValuesSection;
